module.exports = __webpack_public_path__ + "media/images/eyecatch-caution-safe-zone-d3447efc18d70b5a823eeb6838c4e9b9.svg";